import { render } from "./TheFirstDepositCard.vue?vue&type=template&id=4caa44d2&scoped=true&ts=true"
import script from "./TheFirstDepositCard.vue?vue&type=script&lang=ts"
export * from "./TheFirstDepositCard.vue?vue&type=script&lang=ts"

import "./TheFirstDepositCard.vue?vue&type=style&index=0&id=4caa44d2&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caa44d2"]])

export default __exports__